import React from 'react';
import PropTypes from 'prop-types';
import { ResourceRequestStatus } from '~/types';
import { ResourceRequestChartBanner } from '~/modules/resourcing/common/components';
import { hasAcceptActionAllowed } from '~/modules/resourcing/common/components/ResourceMatchItem/permissionUtil';
import { ResourceRequestProposeAcceptAllButton } from './ResourceRequestProposeAcceptAllButton';

export const ResourceRequestProposeAcceptAllChartBanner = ({
  resourceRequests,
  project
}) => {
  const hasPermission = hasAcceptActionAllowed(project);
  const proposedResourceRequests = hasPermission
    ? resourceRequests.filter(
        resourceRequest =>
          resourceRequest.requestStatus === ResourceRequestStatus.Tentative
      )
    : [];

  return proposedResourceRequests.length ? (
    <ResourceRequestChartBanner messageId="resourceRequestChartBanner.proposedRequests">
      <ResourceRequestProposeAcceptAllButton
        proposedResourceRequests={proposedResourceRequests}
      />
    </ResourceRequestChartBanner>
  ) : null;
};

ResourceRequestProposeAcceptAllChartBanner.propTypes = {
  resourceRequests: PropTypes.array.isRequired,
  project: PropTypes.object
};
export default ResourceRequestProposeAcceptAllChartBanner;
